import "./skills.css";
import { useEffect } from "react";
import { skillsData } from "../../../../data/SkillsData";
import SkillsCard from "../../../skills-card/SkillsCard";
import Heading from "../../../heading/Heading";
import Ukiyo from "ukiyojs";

const Skills = () => {
  // Parallax Image Effect
  useEffect(() => {
    const backgroundEl = document.querySelector(".skills-image");
    const ukiyo = new Ukiyo(backgroundEl, {
      scale: 1.15,
      speed: 2,
      willChange: true,
    });

    return () => {
      ukiyo.destroy();
    };
  }, []);

  return (
    <div className="skills">
      <div className="skills-background">
        <div className="background-overlay"></div>
        <img
          className="skills-image"
          src="/assets/images/image-1.jpg"
          alt="skills-background"
        />
        <div className="background-overlay"></div>
      </div>
      <Heading word="Skills" headingSize="h3" />
      <div className="skills-content d-flex flex-wrap justify-content-center align-items-start">
        {skillsData.map((skill) => (
          <SkillsCard key={skill.id} cardName="skill" {...skill} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
